module.exports = __webpack_public_path__ + "static/media/table-tennis-world-tour.8c5810ce.jpg";